<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <div>
          <material-card
            color="primary"
            title="Devices">
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            />
            <v-btn
              color="general"
              class="mb-2"
              @click="addItem()"
            >New Device</v-btn
            >
            <v-dialog
              v-model="dialogAdd"
              max-width="800px">
              <!-- <template v-slot:activator="{ on }">
                <v-btn color="general" dark class="mb-2" v-on="on"
                  >New Device</v-btn
                >
              </template> -->
              <v-card>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex
                        xs12
                        sm6
                        md4>
                        <v-text-field
                          v-model="addedItem.deviceid"
                          required
                          label="Device Id (Required)"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4>
                        <!-- <v-text-field
                          v-model="addedItem.deviceCount"
                          label="Home Id (Required)"
                          @keypress="isNumber()"
                        /> -->
                        <v-autocomplete
                          v-model="addedItem.deviceCount"
                          :items="homes"
                          dense
                          item-text="text"
                          item-value="home_id"
                          label="Home Id"
                          clearable
                        />
                      </v-flex>

                      <v-flex
                        xs12
                        sm6
                        md4>
                        <!-- <v-text-field
                          v-model="editedItem.device_type"
                          label="Device Type"
                        /> -->
                        <v-autocomplete
                          v-model="addedItem.deviceTypeSelect"
                          :items="deviceTypes"
                          dense
                          item-text="text"
                          item-value="id"
                          @change="updatePhases"
                          return-object
                          label="Device Type (Required)"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4>
                        <v-text-field
                          v-model="addedItem.device_name"
                          label="Device Name (Optional)"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4>
                        <!-- <v-text-field
                          v-model="editedItem.device_type"
                          label="Device Type"
                        /> -->
                        <v-select
                          v-model="addedItem.deviceApplianceTypeSelect"
                          :items="deviceApplianceTypes"
                          dense
                          item-text="text"
                          item-value="id"
                          label="Device Appliance Type (Required)"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4>
                        <!-- <v-text-field
                          v-model="editedItem.tags"
                          label="Projects"
                        /> -->
                        <v-autocomplete
                          v-model="addedItem.projectsSelect"
                          :items="projects"
                          dense
                          multiple
                          label="Projects (Optional)"
                        />
                      </v-flex>
                      <v-flex
                       v-if="phases"
                        xs12
                        sm6
                        md4>
                        <v-autocomplete
                          v-model="addedItem.main_phase"
                          :items="phases"
                          dense
                          item-text="text"
                          item-value="id"
                          label="Main Phase"
                        />
                      </v-flex>
                      <!-- <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="addedItem.user_email"
                          label="User Email (Optional)"
                        />
                      </v-flex> -->
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="blue darken-1"
                    @click="closeAdd">Cancel</v-btn>
                  <v-btn
                    color="green darken-1"
                    @click="addDevice">Add</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog
              v-model="dialogEdit"
              max-width="800px">
              <!-- <template v-slot:activator="{ on }">
                <v-btn color="general" dark class="mb-2" v-on="on"
                  >New Device</v-btn
                >
              </template> -->
              <v-card>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex
                        xs12
                        sm6
                        md4>
                        <v-text-field
                          v-model="editedItem.device_name"
                          label="Device Name"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4>
                        <v-autocomplete
                          v-model="editedItem.device_count"
                          :items="homes"
                          dense
                          required
                          item-text="text"
                          item-value="home_id"
                          label="Home Id (Required)"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4>
                        <v-autocomplete
                          v-model="editedItem.tags"
                          :items="projects"
                          dense
                          multiple
                          label="Projects"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4>
                        <v-autocomplete
                          v-model="editedItem.device_type"
                          :items="deviceTypes"
                          item-text="text"
                          item-value="id"
                          dense
                          return-object
                          @change="updatePhases"
                          label="Device Types"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4>
                        <v-autocomplete
                          v-model="editedItem.device_appliance_type_id"
                          :items="deviceApplianceTypes"
                          dense
                          item-text="text"
                          item-value="id"
                          label="Device Appliance Types"
                        />
                      </v-flex>
                      <v-flex
                       v-if="phases"
                        xs12
                        sm6
                        md4>
                        <v-autocomplete
                          v-model="editedItem.main_phase"
                          :items="phases"
                          dense
                          item-text="text"
                          item-value="id"
                          label="Main Phase"
                        />
                      </v-flex>
                      <!-- <v-flex
                        xs12
                        sm6
                        md4>
                        <v-autocomplete
                          v-model="editedItem.email"
                          :items="users"
                          dense
                          label="Email"
                        />
                      </v-flex> -->
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="blue darken-1"
                    @click="closeEdit">Cancel</v-btn>
                  <v-btn
                    color="green darken-1"
                    @click="editDevice">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog
              v-model="dialogDelete"
              max-width="500px">
              <v-card>
                <v-card-title
                  class="headline"
                >Are you sure you want to delete this device?</v-card-title
                >
                <v-card-actions>
                  <v-spacer/>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="closeDelete"
                  >Cancel</v-btn
                  >
                  <v-btn
                    color="green darken-1"
                    text
                    @click="deleteItemConfirm"
                  >OK</v-btn
                  >
                  <v-spacer/>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-data-table
              :headers="headers"
              :items="DeviceList"
              :search="search"
              class="elevation-1 devices-table"
              hide-actions
            >
              <!-- change table header background and text color(or other properties) -->
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <!-- <td>{{ props.item.id }}</td> -->
                <td class="">{{ props.item.deviceid }}</td>
                <td class="">{{ props.item.device_name }}</td>
                <td class="">
                  {{
                    props.item.device_count !== null &&
                      props.item.device_count !== ""
                      ? props.item.device_count
                      : "-"
                  }}
                </td>
                <td class="">
                  {{
                    props.item.address !== null &&
                      props.item.address !== ""
                      ? props.item.address
                      : "-"
                  }}
                </td>
                <td class="">{{ props.item.device_type_text }}</td>
                <td class="">{{ props.item.device_appliance_type_text }}</td>
                <td class="">{{ props.item.main_phase }}</td>
                <td class="">{{ formatEmail(props.item.email) }}</td>
                <td class="">
                  {{ formatTags(props.item.tags) }}
                </td>
                <td class="">{{ formatDate(props.item.registeredat) }}</td>
                <td class="justify-center ">
                  <v-icon
                    medium
                    class="mr-2"
                    @click="editItem(props.item)"
                  >edit</v-icon
                  >
                  <v-icon
                    medium
                    @click="deleteItem(props.item)">delete</v-icon>
                </td>
              </template>
            </v-data-table>
            <v-snackbar
              v-model="snack"
              :timeout="3000"
              :color="snackColor">
              {{ snackText }}
              <v-btn
                flat
                @click="snack = false">Close</v-btn>
            </v-snackbar>
          </material-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'

export default {
  data: () => ({
    snack: false,
    snackColor: '',
    snackText: '',
    pagination: {},
    DeviceList: [],
    checkboxAdmin: true,
    checkboxActive: true,
    rowsAmount: [
      10,
      15,
      20,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    dialogAdd: false,
    dialogDelete: false,
    dialogEdit: false,
    search: '',
    headers: [
      { text: 'Id', value: 'id', align: ' d-none' },
      { text: 'Device Id', value: 'deviceid' },
      { text: 'Device Name', value: 'device_name' },
      { text: 'Home ID', value: 'device_count' },
      { text: 'Home Address', value: 'address' },
      { text: 'Device Type', value: 'device_type_text' },
      { text: 'Device Appliance Type', value: 'device_appliance_type_text' },
      { text: 'Main Phase', value: 'main_phase' },
      { text: 'User Email', value: 'email' },
      { text: 'Projects', value: 'tags' },
      { text: 'Registered At', value: 'registeredat' },
      { text: 'Actions', value: 'actions', sortable: false }
    ],
    editedIndex: -1,
    deletedIndex: -1,
    deletedItem: {},
    editedItem: {
      deviceid: '',
      device_name: '',
      device_count: null,
      device_type: null,
      device_appliance_type_id: null,
      main_phase: null,
      email: '',
      tags: ''
    },
    addedIndex: -1,
    addedItem: {
      deviceid: '',
      device_name: '',
      deviceTypeSelect: [],
      deviceApplianceTypeSelect: null,
      deviceCount: null,
      main_phase: null,
      projectsSelect: [],
      user_email: ''
    },
    defaultItem: {},
    deviceTypes: [],
    phases: undefined,
    deviceApplianceTypes: [],
    projects: [],
    users: [],
    homes: []
  }),

  watch: {
    dialogDelete (val) {
      val || this.closeDelete()
    },
    dialogAdd (val) {
      val || this.closeAdd()
    },
    dialogEdit (val) {
      val || this.closeEdit()
    }
  },
  // called when page is created before dom
  created () {
    this.getDevices()
    this.getHomes()
    this.getProjects()
    this.getDeviceTypes()
    this.getDeviceApplianceTypes()
    this.getUsers()
    // this.$store.dispatch('autoRefreshToken')
    // .then(response => console.log(response))
    // .catch(error => console.log(error))
  },

  methods: {
    getDevices () {
      this.$http
        .get('devices')
        .then((response) => {
          this.DeviceList = response.data
          localStorage.setItem('token', response.headers.token)
        })
        .catch((error) => console.log(error))
    },
    getHomes () {
      this.$http
        .get('homes')
        .then((response) => {
          this.homes = response.data.map((item) => {
            item.text = `${item.name} | ${item.address} | ${item.email}`
            return item
          })
          localStorage.setItem('token', response.headers.token)
        })
        .catch((error) => console.log(error))
    },
    getDeviceTypes () {
      this.$http
        .get('/devices/types')
        .then((response) => {
          console.log('DeviceTypes', response.data)
          this.deviceTypes = response.data;
          // var obj = response.data.projects
          // this.projects = []
          // for (var i = 0; i < obj.length; i++) {
          //   this.deviceTypes.push(obj[i].project)
          // }
        })
        .catch((error) => console.log(error))
    },
    getDeviceApplianceTypes () {
      this.$http
        .get('/devices/appliance_types')
        .then((response) => {
          console.log('DeviceApplianceTypes', response.data)
          this.deviceApplianceTypes = response.data;
          // var obj = response.data.projects
          // this.projects = []
          // for (var i = 0; i < obj.length; i++) {
          //   this.deviceTypes.push(obj[i].project)
          // }
        })
        .catch((error) => console.log(error))
    },
    getProjects () {
      this.$http
        .get('projects')
        .then((response) => {
          var obj = response.data.projects
          this.projects = []
          for (var i = 0; i < obj.length; i++) {
            this.projects.push(obj[i].project)
          }
        })
        .catch((error) => console.log(error))
    },
    getUsers () {
      this.$http
        .get('admin/users')
        .then((response) => {
          var obj = response.data
          this.users = []
          for (var i = 0; i < obj.length; i++) {
            this.users.push(obj[i].email)
          }
        })
        .catch((error) => console.log(error))
    },

    formatDate (datetime) {
      return moment(datetime).format('MMM DD, YYYY HH:mm:ss')
    },

    formatDeviceType (type) {
      let deviceTypeString = 'Single Phase'
      if (type == 1) {
        return 'Single Phase'
      } else if (type == 2) {
        return 'Three Phase'
      }
    },

    updatePhases(item) {
      console.log('Update phases', item)
      this.phases = item.phases;
      if (this.phases === null)
      {
        console.log('Phases is null')
        this.editedItem.main_phase = null;
      }
    },

    formatTags (tags) {
      if (tags !== null) {
        let formattedTags = ''
        for (var i = 0; i < tags.length; i++) {
          formattedTags = formattedTags.concat(tags[i] + ', ')
        }
        formattedTags = formattedTags.replace(/,\s*$/, '')
        return formattedTags
        // return tags.toString();
      } else {
        return '-'
      }
    },

    formatEmail (email) {
      if (email !== null && email !== '' && email !== 'admin@mydomx.eu') {
        return email
      } else {
        return '-'
      }
    },

    callTableAction (item, endpoint, method) {
      let tableItem = this.editedItem
      this.$store
        .dispatch('devicesTableActions', { endpoint, tableItem, method })
        .then((response) => this.saveInline())
        .catch((error) => {
          console.log(error)
          this.cancelInline
        })
    },

    isNumber (evt) {
      evt = evt || window.event
      let charCode = evt.which || evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault()
      } else {
        return true
      }
      return false
    },

    validateEmail (inputText) {
      var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
      if (inputText.match(mailformat)) {
        return true
      } else {
        return false
      }
    },

    // ADD

    addItem () {
      this.dialogAdd = true
      this.phases = null;
    },
    addDevice () {
      if (
        this.addedItem.deviceid == '' ||
        this.addedItem.deviceid == undefined ||
        this.addedItem.deviceTypeSelect == '' ||
        this.addedItem.deviceTypeSelect == undefined ||
        this.addedItem.deviceApplianceTypeSelect == '' ||
        this.addedItem.deviceApplianceTypeSelect == undefined  
        ) {
          this.requiredInline()
        }
      // else if (
      //   this.addedItem.user_email !== "" &&
      //   this.addedItem.user_email !== undefined &&
      //   !this.validateEmail(this.addedItem.user_email)
      // ) {
      //   this.emailErrorInline();
      // }
      else {
        let objectForAddDevice = {}
        objectForAddDevice.deviceId = this.addedItem.deviceid

        // objectForAddDevice.device_type =
        //   this.addedItem.deviceTypeSelect == "Single Phase" ? 1 : 2;
        objectForAddDevice.device_type = this.addedItem.deviceTypeSelect.id
        objectForAddDevice.device_appliance_type = this.addedItem.deviceApplianceTypeSelect

        objectForAddDevice.device_name = this.addedItem.device_name
        objectForAddDevice.main_phase = this.addedItem.main_phase

        if(this.addedItem.deviceCount !== null) {
          objectForAddDevice.deviceCount = this.addedItem.deviceCount
        }

        if (
          this.addedItem.projectsSelect !== undefined &&
          this.addedItem.projectsSelect.length !== 0
        ) {
          objectForAddDevice.tags = JSON.stringify(
            this.addedItem.projectsSelect
          )
        }
        // if (
        //   this.addedItem.user_email !== "" &&
        //   this.addedItem.user_email !== undefined
        // ) {
        //   objectForAddDevice.user_email = this.addedItem.user_email;
        // }

        let endpoint = `devices`
        let method = 'post'
        let tableItem = objectForAddDevice
        this.$store
          .dispatch('addDevice', { endpoint, tableItem, method })
          .then((response) => {
            this.saveInline()
            this.getDevices()
          })
          .catch((error) => {
            // console.log(error.response.status);
            this.apiErrorInline()
          })

        this.closeAdd()
      }
    },

    closeAdd () {
      this.dialogAdd = false
      setTimeout(() => {
        this.addedItem = Object.assign({}, this.defaultItem)
        this.addedIndex = -1
      }, 300)
    },

    // DELETE

    deleteItem (item) {
      this.deletedIndex = this.DeviceList.indexOf(item)
      this.deletedItem = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm () {
      let endpoint = `devices/${this.deletedItem.deviceid}`
      let method = 'delete'
      let tableItem = this.deletedItem
      this.$store
        .dispatch('deleteDevice', { endpoint, tableItem, method })
        .then((response) => {
          this.DeviceList.splice(this.deletedIndex, 1)
          this.saveInline()
        })
        .catch((error) => {
          console.log(error)
          this.apiErrorInline()
        })

      this.closeDelete()
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.deletedItem = Object.assign({}, this.defaultItem)
        this.deletedItem = -1
      })
    },

    // EDIT

    editItem (item) {
      this.editedIndex = this.DeviceList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      
      let foundObj = this.deviceTypes.find((i) => i.id === item.device_type);
      if (foundObj) {
        this.phases = foundObj.phases;
      }
      this.dialogEdit = true
    },

    closeEdit () {
      this.dialogEdit = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedItem = -1
      })
    },

    editDevice () {
      // console.log("editted item: ", this.editedItem);
      // if (
      //   this.editedItem.device_name == "" ||
      //   this.editedItem.device_name == undefined
      // ) {
      //   this.requiredInline();
      // } else {
      let objectForEditDevice = {}
      objectForEditDevice.device_name = this.editedItem.device_name
      objectForEditDevice.device_count = this.editedItem.device_count
      objectForEditDevice.device_type = this.editedItem.device_type.id
      objectForEditDevice.main_phase = this.editedItem.main_phase
      objectForEditDevice.device_appliance_type = this.editedItem.device_appliance_type_id

      if (
        this.editedItem.tags !== null &&
        this.editedItem.tags !== undefined &&
        this.editedItem.tags.length !== 0
      ) {
        objectForEditDevice.tags = JSON.stringify(this.editedItem.tags)
      } else {
        objectForEditDevice.tags = null
      }

      objectForEditDevice.user_email = this.editedItem.email

      let endpoint = `devices/${this.editedItem.deviceid}`
      let method = 'patch'
      let tableItem = objectForEditDevice
      this.$store
        .dispatch('editDevice', { endpoint, tableItem, method })
        .then((response) => {
          this.saveInline()
          this.getDevices()
        })
        .catch((error) => {
          console.log(error)
          this.apiErrorInline()
        })

      this.closeEdit()
      // }
    },

    // toasts/snackbar messages for actions
    saveInline () {
      this.snack = true
      this.snackColor = 'heron_success'
      this.snackText = 'Success'
    },
    cancelInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    apiErrorInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Something went wrong'
    },
    requiredInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Fill all required fields'
    },
    emailErrorInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Enter a valid Email'
    },
    reset () {
      this.snack = true
      this.snackColor = 'heron_success'
      this.snackText = 'Data reset to default'
    },
    openInline () {
      this.snack = true
      this.snackColor = 'heron_info'
      this.snackText = 'Dialog opened'
    },
    closeInline () {
      console.log('Dialog closed')
    }
  }
}
</script>

<style>
table.v-table thead tr {
  color: red !important;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
.devices-table {
  max-height: 80vh;
  overflow-y: auto;
}
</style>
